import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import { getSearch } from '../../utils/http'
import Selected from './Selected'
import Choose from './Choose'
import MajorDetail from './MajorDetail'
import ProfessionDetail from './ProfessionDetail'
import './index.less'
import { getPurposeSchoolAndSpecialty } from '../../api/schoolWishList';

class MajorWishList extends Component {

    state = {
        showIntro: false,
        codes: [],
    }

    componentWillMount() {
        // 获取保存的专业信息
        // getSpecialtyIntention().then(res => {
        //     if (Array.isArray(res.data) && res.data.length && (getSearch().type !== 'reset')) {
        //         let codes = res.data.map(d => d.code)
        //         this.setState({
        //             codes: codes
        //         })
        //     } else {
        //         // 如果列表为空，从query里取
        //         const searchObj = getSearch();
        //         let codes = searchObj.codes ? searchObj.codes.split(',') : [];
        //         this.setState({
        //             codes: codes
        //         });
        //     }
        // });
        //获取意向学校和专业
        getPurposeSchoolAndSpecialty().then(res => {
            //这里注意，新用户的specialties为null，保存过后的空值就变成了[]
            if(res.data && res.data.specialties && (getSearch().type !== 'reset')){//res.data.specialties为[]或[...]时代表保存过意向专业
                let codes = res.data.specialties.map(d => d.code)
                this.setState({
                    codes: codes
                })
            }else {//res.data.specialties为null时代表没有保存过意向专业
                // 如果列表为空，从query里取
                const searchObj = getSearch();
                let codes = searchObj.codes ? searchObj.codes.split(',') : [];
                this.setState({
                    codes: codes
                });
            }
        });

    }

    handleCodesChange(codes = [], type) {
        this.setState(() => {
            return {
                codes,
            }
        });
        const {
            history,
            match
        } = this.props;
        if (type === 'selected') {
            history.replace(match.url + `?codes=${codes.join(',')}`);
        }
        // window.location = window.location.origin + window.location.pathname + `?codes=${codes.join(',')}`;
    }

    render() {
        const { match } = this.props;
        const { codes } = this.state;
        return (
            <Switch>
                <Route exact path={`${match.url}`} render={props =>
                    <Selected codes={codes} changeCodes={this.handleCodesChange.bind(this)} {...props} />
                } />
                <Route path={`${match.url}/choose`} render={props =>
                    <Choose codes={codes} changeCodes={this.handleCodesChange.bind(this)} {...props} />
                } />
                <Route path={`${match.url}/major/:id`} render={props =>
                    <MajorDetail codes={codes} changeCodes={this.handleCodesChange.bind(this)} {...props} />
                } />
                <Route path={`${match.url}/profession/:id`} render={props =>
                    <ProfessionDetail {...props} />
                } />
            </Switch>
        )
    }
}

export default MajorWishList



// WEBPACK FOOTER //
// ./src/pages/MajorWishList/index.js